if (!customElements.get('cc-video-cards')) {
  customElements.define('cc-video-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.track = this.querySelector('[data-video-track]');
      if (!this.track) return;
      this.ready = true;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous = this.querySelector('[data-video-prev]');
      this.next = this.querySelector('[data-video-next]');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.items = new Map([...this.querySelectorAll('.cc-videos__item')].map(item => [item, { visible: false, video: item.querySelector('video'), failed: false }]));
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
        this.updatePlayback();
      }, options);
      this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => { this.items.get(entry.target).visible = entry.isIntersecting && entry.intersectionRatio >= 0.15; });
        this.updatePlayback();
      }, { threshold: [0, 0.15] });
      this.items.forEach((state, item) => this.visibility.observe(item));
      this.resize = new ResizeObserver(() => this.updateArrows());
      this.resize.observe(this.track);
      this.updateToggle();
      this.updateArrows();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.visibility?.disconnect();
      this.resize?.disconnect();
      this.items?.forEach(state => state.video?.pause());
      this.ready = false;
    }
    move(direction) {
      const card = this.track.querySelector('.cc-videos__item');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateArrows() {
      this.previous.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    updateToggle() {
      this.toggle.hidden = false;
      const label = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.setAttribute('aria-label', label);
      this.toggle.querySelector('[data-video-toggle-label]').textContent = label;
      this.toggle.dataset.paused = String(this.paused);
    }
    updatePlayback() {
      this.items.forEach((state, item) => {
        const shouldPlay = state.visible && !this.paused && !document.hidden && !state.failed;
        if (shouldPlay && !state.video) {
          const template = item.querySelector('[data-video-template]');
          if (!template) return;
          state.video = template.content.querySelector('video').cloneNode(true);
          state.video.muted = true;
          state.video.defaultMuted = true;
          state.video.autoplay = true;
          state.video.loop = true;
          state.video.playsInline = true;
          state.video.controls = false;
          state.video.tabIndex = -1;
          state.video.setAttribute('aria-hidden', 'true');
          state.video.addEventListener('playing', () => item.classList.add('is-playing'), { signal: this.events.signal });
          state.video.addEventListener('error', () => { state.failed = true; item.classList.remove('is-playing'); }, { once: true, signal: this.events.signal });
          item.querySelector('[data-video-surface]').append(state.video);
        }
        if (!state.video) return;
        if (shouldPlay) {
          if (state.video.paused) state.video.play()?.catch(() => {});
        } else state.video.pause();
      });
    }
  });
}
